export const getDesignerOptionRefs = (state) => state.customDesignerData.designerOptionRefs || [];
export const designerMobileProductsListOpen = (state) => state.customDesignerData.designerMobileProductsListOpen || [];
export const getDesignerMobileModalContentOptions = (state) => state.customDesignerData.designerMobileModalContentOptions;
export const getCurrentDesignerMobileModalContentOptions = (state) => state.customDesignerData.designerMobileModalContent || null;
